module.exports = __webpack_public_path__ + "img/im_logo.42b7104c.png";